import React, { useEffect, useState } from "react";
import EmployeesSapTable from "./components/EmployeesSapTable";
import FilterSap from "./modals/FilterSap";
import Switch from "@material-ui/core/Switch/index";
import FormControlLabel from "@material-ui/core/FormControlLabel/index";
import axios from "axios";
import { updateObject } from "../../../helpers/updateObject";
import LogSap from "./modals/LogSap";
import Delete from "./modals/Remove";
import { useSelector } from "react-redux";
import LogSapFinger from "./modals/LogSapFinger";
import LogFingerSapEmployee from "./modals/LogFingerSapEmployee";
import QrEmployee from "./modals/QrEmployee";
import EditLogFaceEmployee from "./modals/EditLogFaceEmployee";
import View from "./modals/ViewSap";
import Divider from "@material-ui/core/Divider/index";
import CreatePinSAP from "./modals/CreatePinSAP";
import EditSap from "./modals/EditSap";
import PlusIcon from "@material-ui/icons/Add";

function EmployeesSap(props) {
  const [showView, setShowView] = useState(false);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showRegistred, setShowRegistred] = useState(undefined);
  const [showUnregistred, setShowUnregistred] = useState(undefined);
  const [showRegistredWithoutDevice, setShowRegistredWithoutDevice] = useState(
    undefined
  );
  const [showRemove, setShowRemove] = useState(false);
  const [showLog, setShowLog] = useState(false);
  const [showLogFingerStatus, setShowLogFingerStatus] = useState(false);
  const [showQrStatus, setShowQrStatus] = useState(false);
  const [showLogFinger, setShowLogFinger] = useState(false);
  const [showEditLogFace, setShowEditLogFace] = useState(false);
  const [saps, setSaps] = useState([]);
  const [face, setFace] = useState([]);
  const [chooseSapId, setChooseSapId] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [deleteSapsIds, setDeleteSapsIds] = useState([]);
  const [showFilter, setShowFilter] = React.useState(false);
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(10);
  const [count, setCount] = useState(0);
  const [orderBy, setOrderBy] = useState("desc");
  const [sortField, setSortField] = useState("updatedAt");
  const [filterInputs, setFilterInputs] = useState({
    duty: "",
    employeeDeviceStatus: "",
    pin: "",
    status: "",
    structureId: "",
    surname: "",
    middleName: "",
    name: "",
  });
  const token = useSelector((state) => state.auth.token);

  function handleChange() {
    setShowFilter((key) => !key);
  }
  const toggleDrawer = (open) => (event) => {
    setShowView(open);
  };
  const onSaps = (orderBy, sortField, skip, take, filterInputs = {}) => {
    const {
      duty,
      surname,
      middleName,
      name,
      pin,
      status,
      structureId,
    } = filterInputs;
    setIsLoading(true);
    axios
      .get(
        `${
          process.env.REACT_APP_API_URL
        }employee?dir=${orderBy}&field=${sortField}&pageNumber=${skip}&pageSize=${take}&source=SAP${
          duty ? `&duty=${duty}` : ""
        }${middleName ? `&middleName=${middleName}` : ""}${
          name ? `&name=${name}` : ""
        }${pin ? `&pin=${pin}` : ""}${status ? `&status=${status}` : ""}${
          structureId ? `&structureId=${structureId}` : ""
        }${surname ? `&surname=${surname}` : ""}`
      )
      .then(({ data: { content, totalElements } }) => {
        setIsLoading(false);
        setSaps(content);
        setIsError(false);
        setCount(totalElements);
      })
      .catch(() => {
        setIsLoading(false);
        setSaps([]);
        setIsError(true);
      });
  };

  const onSapChoose = (id) => {
    return axios.get(
      `${process.env.REACT_APP_API_URL}employee/${id ? id : ""}`
    );
  };

  const onFaceChoose = (id) => {
    setFace("");
    const headers = {
      Authorization: `bearer ${token}`,
    };
    axios
      .get(`${process.env.REACT_APP_API_URL}hikvision/face/${id}`, { headers })
      .then(({ data }) => {
        setFace(data);
      });
  };

  const filterInputsUpdate = (name, value) => {
    const updateFiltersInput = updateObject(filterInputs, {
      [name]: value,
    });

    setFilterInputs(updateFiltersInput);
    setSkip(0);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      onSaps(orderBy, sortField, skip, take, filterInputs);
    }, 500);
    return () => clearTimeout(timer);
  }, [orderBy, sortField, skip, take, filterInputs]);

  useEffect(() => {
    const timer = setTimeout(() => {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}employee/registered-count?source=SAP`
        )
        .then((res) => {
          setShowRegistred(res.data.employeeCount);
        });
    }, 500);
    return () => clearTimeout(timer);
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}employee/registered-without-device-count?source=SAP`
        )
        .then((res) => {
          setShowRegistredWithoutDevice(res.data.employeeCount);
        });
    }, 500);
    return () => clearTimeout(timer);
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}employee/unregistered-count?source=SAP`
        )
        .then((res) => {
          setShowUnregistred(res.data.employeeCount);
        });
    }, 500);
    return () => clearTimeout(timer);
  });

  const [structureId, setStructureId] = useState();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}structure/select?source=SAP`)
      .then((res) => {
        const structureId = res.data.map(({ id, name }) => ({
          value: id,
          label: name,
        }));

        setStructureId(structureId);
      });
  }, []);

  const [dutyId, setDutyId] = useState();

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}duty`).then((res) => {
      const dutyId = res.data?.content.map(({ id, name }) => ({
        value: id,
        label: name,
      }));

      setDutyId(dutyId);
    });
  }, []);

  const [deviceId, setDeviceId] = useState();

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}device`).then((res) => {
      const deviceId = res?.data?.content?.map(({ id, name }) => ({
        value: id,
        label: name,
      }));

      setDeviceId(deviceId);
    });
  }, []);

  return (
    <div className="row bg-white rounded SHADOW">
      <div className="col-12 d-flex align-items-center mt-3  justify-content-end">
        {/* <FormControl>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
          >
            <FormControlLabel value="female" control={<Radio />} label={`Qeydiyyatlı(${showRegistred ? showRegistred:""})`} />
            <FormControlLabel value="male" control={<Radio />} label={`Qeydiyyatsız(${showUnregistred?showUnregistred:""})`} />
            <FormControlLabel value="other" control={<Radio />} label={`Qeydiyyatlı (qurğusuz)(${showRegistredWithoutDevice?showRegistredWithoutDevice:""})`} />

          </RadioGroup>
        </FormControl> */}
        <FormControlLabel
          control={
            <Switch
              checked={showFilter}
              onChange={handleChange}
              color="secondary"
            />
          }
          label={showFilter ? "Filtri gizlət" : "Filtri göstər"}
          className=" mb-0 "
          style={{ marginRight: "40px" }}
        />
        <button
          className="flex-shrink-0 btn btn-sm btn-icon btn-bg-light btn-text-primary btn-hover-primary mr-2 h5 rounded-circle flex-shrink-0 "
          onClick={() => setShowCreate(true)}
        >
          <PlusIcon />
        </button>
      </div>
      <Divider className="w-100" />

      <EmployeesSapTable
        saps={saps}
        isLoading={isLoading}
        isError={isError}
        setDeleteSapsIds={setDeleteSapsIds}
        deleteSapsIds={deleteSapsIds}
        setSortField={setSortField}
        setOrderByTable={setOrderBy}
        sortField={sortField}
        orderBy={orderBy}
        count={count}
        setShowEdit={setShowEdit}
        setShowRemove={setShowRemove}
        updateSkip={setSkip}
        updateTake={setTake}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
        setShowLog={setShowLog}
        setShowLogFinger={setShowLogFinger}
        setChooseSapId={setChooseSapId}
        setOpenView={toggleDrawer(true)}
        setShowLogFingerStatus={setShowLogFingerStatus}
        setShowEditLogFace={setShowEditLogFace}
        setShowQrStatus={setShowQrStatus}
        setShowCreate={setShowCreate}
        onFaceChoose={onFaceChoose}
      />
      <LogSap
        chooseSapId={chooseSapId}
        onSapChoose={onSapChoose}
        onSaps={onSaps}
        filterInputs={filterInputs}
        setChooseSapId={setChooseSapId}
        showLog={showLog}
        setShowLog={setShowLog}
      />
      <LogFingerSapEmployee
        chooseSapId={chooseSapId}
        onSapChoose={onSapChoose}
        onSaps={onSaps}
        filterInputs={filterInputs}
        setChooseSapId={setChooseSapId}
        showLog={showLogFingerStatus}
        setShowLog={setShowLogFingerStatus}
      />
      <QrEmployee
        chooseSapId={chooseSapId}
        onSapChoose={onSapChoose}
        onSaps={onSaps}
        filterInputs={filterInputs}
        setChooseSapId={setChooseSapId}
        show={showQrStatus}
        onHide={setShowQrStatus}
      />
      {showEditLogFace && (
        <EditLogFaceEmployee
          chooseId={chooseSapId}
          onSapChoose={onSapChoose}
          onSaps={onSaps}
          face={face}
          filterInputs={filterInputs}
          setChooseSapId={setChooseSapId}
          show={showEditLogFace}
          onHide={setShowEditLogFace}
          onFaceChoose={onFaceChoose}
        />
      )}
      <LogSapFinger
        chooseSapId={chooseSapId}
        onSapChoose={onSapChoose}
        onSaps={onSaps}
        filterInputs={filterInputs}
        setChooseSapId={setChooseSapId}
        show={showLogFinger}
        onHide={setShowLogFinger}
        deviceId={deviceId}
        skip={skip}
        take={take}
        sortField={sortField}
        orderBy={orderBy}
      />
      <FilterSap
        show={showFilter}
        onHide={handleChange}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
        setFilterInputs={setFilterInputs}
        structureId={structureId}
      />

      {showCreate && (
        <CreatePinSAP
          show={showCreate}
          onHide={setShowCreate}
          onSaps={onSaps}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
          structureId={structureId}
          dutyId={dutyId}
          filterInputs={filterInputs}
        />
      )}

      <Delete
        id={chooseSapId}
        show={showRemove}
        onHide={setShowRemove}
        onSaps={onSaps}
        skip={skip}
        take={take}
        sortField={sortField}
        orderBy={orderBy}
        filterInputs={filterInputs}
      />
      {showEdit && (
        <EditSap
          show={showEdit}
          onHide={setShowEdit}
          onSaps={onSaps}
          onSapChoose={onSapChoose}
          chooseSapId={chooseSapId}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
          filterInputs={filterInputs}
          structureId={structureId}
          dutyId={dutyId}
        />
      )}

      {showView && (
        <View
          open={showView}
          onClose={toggleDrawer(false)}
          onSapChoose={onSapChoose}
          chooseSapId={chooseSapId}
        />
      )}
    </div>
  );
}

export default EmployeesSap;
